import { usePreference } from '@fs/zion-preferences'

// FS Labs enrollment lives in the fslabs.labs array; the source-centric lab is on for this user when
// the array contains our lab id (the same array setLabsPreference reads/writes).
export const SOURCE_CENTRIC_LABS_ID = '3N8653561K2SG0XG4SM0F'

export default function useSourceCentricLabIsOn(): boolean {
  const labs = usePreference<string[]>('fslabs.labs')

  return Array.isArray(labs) && labs.includes(SOURCE_CENTRIC_LABS_ID)
}
